import React from "react";
import ModernImageForm from "./ModernImageForm";

interface Props {
  singleImage?: boolean;
}

export default function ImageForm(props: Props) {
  return <ModernImageForm {...props} />;
}